class QuoterFilter {
    static filterResults(filterObject, quotes) {
        const normalizedQuotes = Array.isArray(quotes) ? quotes : (quotes ? [quotes] : []);
        if (!filterObject) { return normalizedQuotes; }
        let results = [...normalizedQuotes];
        if (filterObject.digitalOnly) { results = results.filter(x => (x.isDigitalProduct === true && x.requiresPhoneInterview === false)); }
        if (filterObject.phoneOnly) { results = results.filter(x => (x.isDigitalProduct === false && x.requiresPhoneInterview === true)); }
        if (filterObject.simplifiedIssueOnly) { results = results.filter(x => x.productHighlightInfo.some(y => y.productHighlight === "Simplified Issue")); }
        if (filterObject.guaranteedIssueOnly) { results = results.filter(x => x.productHighlightInfo.some(y => y.productHighlight === "Guaranteed Issue")); }
        if (filterObject.levelDeathBenefit) { results = results.filter(x => x.productHighlightInfo.some(y => y.productHighlight === "Level Death Benefit")); }
        if (filterObject.gradedDeathBenefit) { results = results.filter(x => x.productHighlightInfo.some(y => y.productHighlight === "Graded Death Benefit")); }
        if (filterObject.modifiedDeathBenefit) { results = results.filter(x => x.productHighlightInfo.some(y => y.productHighlight === "Modified Death Benefit")); }
        return results;
    };
};

export default QuoterFilter;